export default __webpack_public_path__ + "static/media/villas_web.cc94d978.svg";